import React from 'react';
import { useSelector } from 'react-redux';
import { useLocalStorageState } from 'ahooks';
import { useNavigate } from 'react-router-dom';
import { SubscriptionUpgradeCard } from './SubscriptionUpgradeCard';
import {
  isWhitelabelAccount,
  isResellerAccount,
} from '../../../../shared/utils';
import { getAppSettings } from '../../../../selectors';
import { useGlobals } from '../../../../globals-context';
import { BETA_TOGGLES } from '../../../../features/beta/screens/Beta';

type SidebarActionCardsProps = {
  sideMenuCollapsed: boolean;
};

export function SidebarActionCards({
  sideMenuCollapsed,
}: SidebarActionCardsProps) {
  if (sideMenuCollapsed) return;

  const navigate = useNavigate();
  const { trackMethod } = useGlobals() as any;

  const currentMerchant = useSelector((state: any) => state.currentMerchant);
  const { subscriptionPartner } =
    useSelector((state: any) => getAppSettings(state)) || {};

  const packageCode = useSelector(
    (state: any) => state.currentMerchant.packageCode
  );
  const hasPaidSubscription = currentMerchant.subscriptionStatus === 'active';
  const isWhitelabel = isWhitelabelAccount(currentMerchant?.whiteLabel);
  const isReseller = isResellerAccount(subscriptionPartner);

  const showSubscriptionUpgradeCard =
    hasPaidSubscription &&
    !isWhitelabel &&
    !isReseller &&
    packageCode !== 'shore_pos_premium';

  const [showBetaSubscriptionUpgradeCard] = useLocalStorageState<boolean>(
    BETA_TOGGLES.subscriptionUpgradeCard.key,
    {
      listenStorageChange: true,
    }
  );

  const handleOnCardClick = () => {
    navigate('/subscription/upgrade');
    trackMethod('subscription_upgrade_card_clicked');
  };

  return (
    <>
      {showBetaSubscriptionUpgradeCard && showSubscriptionUpgradeCard && (
        <SubscriptionUpgradeCard onCardClick={handleOnCardClick} />
      )}
    </>
  );
}
